import { Component, OnInit } from "@angular/core";
import { BaseControlComponent } from "../../../../../../../form-controls/components/base-control/base-control.component";
import { ensureWellComponentConfig, WellConfigType } from "../../../../../../../form-controls/components/new-casing-plan/models/casing-plan.model";
import { ContextInteractionService } from "../../../../../../../form-controls/services/context-interaction.service";

@Component({
    selector: "app-aor-map-control-data-config",
    templateUrl: "./area-of-review-map-control-data-config.component.html",
    standalone: false
})
export class AreaOfReviewMapControlDataConfigComponent extends BaseControlComponent implements OnInit {
    static componentName = "AreaOfReviewMapControlDataConfigComponent";

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

    ngOnInit() {
        this.initializeConfig();
    }

    initializeConfig(): void {
        this.componentData.config.wellDataPoints = ensureWellComponentConfig(WellConfigType.AreaOfReviewMap, this.componentData.config.wellDataPoints);
    }

}
